import axios from "axios";
import { send_welcom_package } from "../../../Api/Api";
import { toast } from "react-toastify";
const sendWelcomePackageAction = async (data) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "POST",
    baseURL: `${send_welcom_package}`,
    headers: headers,
    data: data,
    // params: {
    //   id: id,
    // },
  });
  if (response?.status == 200) {
    toast.success("Welcome Package Sent Successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  return response.data;
};

const sendwelcomePackageService = {
  sendWelcomePackageAction,
};
export default sendwelcomePackageService;
